import {momentRange} from "../../../../../gd/convert/moment-range";

export default class ReportSelfPlanning_Settings {

    // View settings
    public daterange       : DateRange
    public userId          : ID
    public departmentId    : ID

    constructor(data: any) {
        this.daterange        = data?.daterange ? momentRange(data.daterange.start, data.daterange.end) : momentRange(moment().subtract(1, "month"), moment())
        this.userId           = _.get(data, "userId", null)
        this.departmentId     = _.get(data, "departmentId", null)
    }

    toJSON(): JSONObject {
        const result : JSONObject =  {
            userId           : this.userId,
            departmentId     : this.departmentId
        }

        if (this.daterange) {
            result['daterange'] = {
                start   : this.daterange.start.format("YYYY-MM-DD"),
                end     : this.daterange.end.format("YYYY-MM-DD")
            }
        }

        return result
    }
}
